module.exports = __webpack_public_path__ + "static/media/TECH_PANEL.f2aa17da.png";